import get from 'lodash/get';
import siteData from './site_data_util';
import baseSeoUtil from './base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData[site] || {};
  const siteHumanReadable = get(siteConf, '[og:site_name]');
  const category = get(state, 'categoryFeaturedFeed.category') || {};
  const categoryName = get(category, 'name');
  const slug = get(category, 'slug');
  const description = category.description || `Innovation in ${categoryName}`;
  let title = categoryName
    ? `${categoryName} | ${siteHumanReadable}`
    : `${siteHumanReadable}`;

  if (category.slug === 'magazine') {
    title = 'Fast Company Magazine';
  }

  const data = baseSeoUtil({
    site,
    siteConf,
    title,
    url: `https://www.${site}.com/${slug}`,
    description,
    articleSection: categoryName
  });

  return data;
}



// WEBPACK FOOTER //
// ./src/utils/seo_utils/category_seo_util.js